import { AnyAction } from 'redux'
import { connect, ConnectedProps } from 'react-redux'
import { produce } from 'immer'
import { RootState } from '../../store'
import { ConfirmProps } from '../Confirm/Confirm'
import { NotifyType } from '../Notify'

export type ConfirmParams = Omit<ConfirmState, 'visible'>

interface ConfirmState {
  id: number
  visible: boolean
  type?: NotifyType
  question: string
  confirmText: string
  cancelText: string
  onConfirm: () => void
}

export type ConfirmStateProps = ConnectedProps<typeof connector>

const initialState: ConfirmState = {
  id: 0,
  visible: false,
  type: 'info',
  question: '',
  confirmText: '',
  cancelText: '',
  onConfirm: () => {}
}

export const actions = {
  push: 'confirm/push',
  confirm: 'confirm/confirm',
  cancel: 'confirm/cancel'
}

export default function reducers (state = initialState, action: AnyAction) {
  switch (action.type) {
    case actions.push:
      return produce(state, draft => {
        draft.id = action.confirm.id
        draft.visible = true
        draft.type = action.confirm.type
        draft.question = action.confirm.question
        draft.confirmText = action.confirm.confirmText
        draft.cancelText = action.confirm.cancelText
        draft.onConfirm = action.confirm.onConfirm
      })
    case actions.confirm:
      return produce(state, draft => {
        draft.visible = initialState.visible
      })
    case actions.cancel:
      return produce(state, draft => {
        draft.visible = initialState.visible
      })
    default:
      return state
  }
}

export const mapDispatchToProps = {
  push (confirm: ConfirmParams) {
    return { type: actions.push, confirm }
  },
  confirm () {
    return { type: actions.confirm }
  },
  cancel () {
    return { type: actions.cancel }
  }
}

export function mapStateToProps (state: RootState, props?: ConfirmProps) {
  return produce(state.confirm, draft => draft)
}

export const connector = connect(mapStateToProps, mapDispatchToProps)
